import React from 'react'
import { FormattedMessage } from 'react-intl'
import { PRIVACY_POLICY_URL, SUPPORT_EMAIL, TERMS_AND_CONDITIONS_URL } from '../constants'

const footerLinkClassName = 'font-semibold text-text-heading underline underline-offset-2 hover:text-brand-700'

const HomeFooter: React.FC = () => {
  return (
    <footer className="flex flex-wrap items-center justify-center gap-x-6 gap-y-3 py-8 text-center text-xs text-gray-500">
      <p>
        <FormattedMessage
          id="home.footer.copyright"
          defaultMessage="© 2026 Inflection Medicine. All rights reserved."
        />
      </p>
      <span aria-hidden>·</span>
      <nav className="flex flex-wrap items-center justify-center gap-x-6 gap-y-2" aria-label="Footer">
        <a href={PRIVACY_POLICY_URL} target="_blank" rel="noopener noreferrer" className={footerLinkClassName}>
          <FormattedMessage id="home.footer.privacyPolicy" defaultMessage="Privacy Policy" />
        </a>
        <a href={TERMS_AND_CONDITIONS_URL} target="_blank" rel="noopener noreferrer" className={footerLinkClassName}>
          <FormattedMessage id="home.footer.termsAndConditions" defaultMessage="Terms & Conditions" />
        </a>
        <a href={`mailto:${SUPPORT_EMAIL}`} className={footerLinkClassName}>
          <FormattedMessage id="home.footer.contactUs" defaultMessage="Contact Us" />
        </a>
      </nav>
    </footer>
  )
}

export default HomeFooter
